module.exports = __webpack_public_path__ + "img/1029.943f9b6e.png";